module.exports = __webpack_public_path__ + "img/10.af8be6dc.png";